import AppHeader from "components/appHeader/AppHeader";
import CertificateAlert from "components/certificateAlert";
import AdminMenu from "components/left-menu/admin_menu";
import ClinicMenu from "components/left-menu/clinic_menu";
import RootLayout from "components/root_layout/rootLayout";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE } from "routes/route";
import { isAuth, isSanwaAdmin } from "utils";
import "./styles.scss";

const PrivateLayout = ({ children }) => {
  if (!isAuth()) {
    return <Redirect to={ROUTE.PUBLIC.LOGIN} />;
  }

  return (
    // Dải cảnh báo đặt trên cùng, trên cả header và menu: cảnh báo hạ tầng
    // cần thấy ngay khi mở trang, không lẫn vào nội dung nghiệp vụ.
    <div className="private-layout-root">
      {isSanwaAdmin() && <CertificateAlert />}
      <RootLayout
        header={<AppHeader />}
        menu={isSanwaAdmin() ? <AdminMenu /> : <ClinicMenu />}
        content={children}
      />
    </div>
  );
};

export default PrivateLayout;
